import { styled, themeGet } from "@twilio-paste/styling-library";
import { Link } from "gatsby";
import React from "react";

const color = "textColors.colorTextLinkStronger";
// Link styles copied from @twilio-paste/core
const StyledLink = styled(Link)`
    color: ${themeGet("textColors.colorTextLink")};
    text-decoration: underline;
    outline: none;

    &:hover {
        color: ${themeGet(color)};
        text-decoration: none;
    }

    &:focus {
        box-shadow: ${themeGet("shadows.shadowFocus")};
        color: ${themeGet(color)};
        text-decoration: none;
    }

    &:active {
        color: ${themeGet(color)};
        text-decoration: none;
    }
`;

export interface SiteLinkProps {
    children: React.ReactNode;
    to: string;
    onClick?: () => void;
}

const SiteLink: React.FC<SiteLinkProps> = ({ children, to, ...props }) => (
    <StyledLink to={to} {...props}>
        {children}
    </StyledLink>
);

export { SiteLink };
